export default {
    name: '商品管理',
    permissionsKey:"YY-SPGL",
    icon: 'el-icon-s-shop',
    children: {
        courseList:{
            name: '商品列表',
            permissionsKey:"YY-SPGL-SPLB",
            path: '/merchandise_manage/merchandise',
        },
    }
};
